"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollectionList = void 0;
const spinner_1 = require("../../components/spinner/spinner");
const theme_1 = require("../../components/theme");
const mithril_1 = require("../../mithril");
const collection_card_1 = require("./collection.card");
const collection_list_style_1 = require("./collection.list.style");
(0, theme_1.addStyles)(collection_list_style_1.Style);
exports.CollectionList = {
    view(state, tag, collectionSummaries) {
        const collectionCards = [];
        for (const collectionSummary of collectionSummaries) {
            const summaryView = collection_card_1.CollectionCard.view(state, tag, collectionSummary);
            collectionCards.push(summaryView);
        }
        return (0, mithril_1.m)('div', { className: collection_list_style_1.CSS.container, key: 'cl-' + tag.objectId }, collectionCards);
    },
    viewLoading(tagId) {
        return (0, mithril_1.m)('div', { className: `${collection_list_style_1.CSS.container} ${collection_list_style_1.CSS.loading}`, key: 'cl-' + tagId }, spinner_1.Spinner.view());
    }
};
//# sourceMappingURL=collection.list.js.map